import Image from 'next/image'

// Idukki brand-mark tile, lime `#CDEB45` ground (per CLAUDE.md
// "Visual brand cues") + the real favicon glyph from
// public/brand/favicon.png. Used wherever a mock surface or cover
// needs the Idukki publisher mark.

const IDUKKI_MARK = '/brand/favicon.png'

export function IdukkiTile({ size = 'md', className = '' }: { size?: 'xs' | 'sm' | 'md' | 'lg'; className?: string }) {
  const px = size === 'xs' ? 20 : size === 'sm' ? 28 : size === 'lg' ? 40 : 32
  return (
    <span
      className={`inline-flex items-center justify-center rounded-md bg-brand-lime shadow-sm ${className}`}
      style={{ height: px, width: px }}
    >
      <Image
        src={IDUKKI_MARK}
        alt="Idukki"
        width={px - 6}
        height={px - 6}
        className="object-contain"
      />
    </span>
  )
}
